import React from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../Components/BackButton";
import UpdateInformationForm from "../Forms/UpdateInformationForm";
import { useDispatch } from "react-redux";
import { clearCurrentRegistrant, updateRegistrant } from "../store/registrant/registrantSlice";
import { changeStep } from "../store/settings/settingsSlice";
import { useSelector } from 'react-redux';
import { getContent } from "../content";

function UpdateInformation() {
    const registrant = useSelector((state) => state.registrant);
    let navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(changeStep([2, 6]));
    }, []);

    const onSubmit = (data) => {
        Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});

        dispatch(updateRegistrant({
            ...data
        }));

        navigate("/eligibility-notice");
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:my-8 lg:mt-16">{getContent('update_information.heading')}</h2>
                <p>{getContent('update_information.content')}</p>
            </div>
            <div className="">
                <div className="border-4 border-evcpa-darkpurple rounded-lg p-8">
                    <UpdateInformationForm submit={onSubmit} />
                </div>
            </div>
        </section>
    );
}

export default UpdateInformation;